import { useFormikContext } from 'formik';
import { useEffect, useMemo } from 'react';
import { Card } from '../../../../card/Card';
import {
  PipelineSettingsFormFields,
  PipelineSettingsFormState
} from '../../interfaces/pipeline-settings-form-state';
import { PipelineConfigRadioGroupWrapper } from '../PipelineConfigRadioGroupWrapper/PipelineConfigRadioGroupWrapper';
import { PipelineReplicationTypeFeatureOptions } from '../../../interfaces/pipeline-settings-config';
import { IntegrationReplicationTypesFactory } from '../../../factories/integrationFactory';

export function PipelineReplicationType({
  disabled,
  featureOptions
}: {
  disabled: boolean;
  featureOptions: PipelineReplicationTypeFeatureOptions;
}) {
  const formikProps = useFormikContext<PipelineSettingsFormState>();

  const recommendedMode = featureOptions.default_value;

  const configModes = useMemo(() => {
    return IntegrationReplicationTypesFactory(featureOptions.options, recommendedMode);
  }, [featureOptions, recommendedMode]);

  useEffect(() => {
    if (!disabled && configModes.length > 0) {
      (async () => {
        await formikProps.setFieldValue(
          PipelineSettingsFormFields.REPLICATION_TYPE,
          recommendedMode
        );
      })();
    }
  }, [configModes, disabled, recommendedMode]);

  if (configModes.length <= 1) {
    return null;
  }

  return (
    <Card
      gridColumns={1}
      className='mt-5'
      title='Replication type'
      subtitle='Choose how you want Hevo to replicate your data'
      dataId='replication-type'
    >
      <PipelineConfigRadioGroupWrapper
        id='replication-type'
        name={PipelineSettingsFormFields.REPLICATION_TYPE}
        defaultValue={formikProps.values[PipelineSettingsFormFields.REPLICATION_TYPE]}
        currentValue={formikProps.values[PipelineSettingsFormFields.REPLICATION_TYPE]}
        className='grid-column-span-1'
        row={false}
        configModes={configModes}
        onChange={async mode => {
          await formikProps.setFieldValue(PipelineSettingsFormFields.REPLICATION_TYPE, mode);
        }}
        disabled={disabled}
      />
    </Card>
  );
}
